export default () => (
  <svg
    width="16"
    height="15"
    viewBox="0 0 16 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style={{ marginTop: 7 }}
  >
    <path d="M1 1.94446H15V9.72224C15 12.2996 12.9107 14.3889 10.3333 14.3889H1V1.94446Z" stroke="#EB5858" />
    <circle cx="10.7231" cy="10.1111" r="4.27778" stroke="#EB5858" />
    <path d="M10.7227 8.16669L10.7227 10.1111H12.2782" stroke="#EB5858" />
    <path d="M3.33398 0V3.5" stroke="#EB5858" />
    <path d="M6.44531 0V3.5" stroke="#EB5858" />
    <path d="M9.55469 0V3.5" stroke="#EB5858" />
    <path d="M12.666 0V3.5" stroke="#EB5858" />
  </svg>
)
